module.exports = __webpack_public_path__ + "static/media/Maximum capacity.41cd09fc.svg";